/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { CurrentUserService } from '@src/app/modules/user/current-user.service';
import { ConfirmDialogService } from '@src/app/shared/dialogs/confirmDialog';
import { MessageService } from '@src/app/shared/message.service';
import { TenantService } from '@src/app/shared/tenant.service';

const TEST_SLUG = 'test-omc';

@Component({
    selector: 'app-purge-test-company',
    imports: [MatButtonModule],
    template: `
        @if (allowed) {
            <button mat-raised-button color="warn" (click)="purge()">
                Purge Test Company
            </button>
        }
    `
})
export class PurgeTestCompanyComponent {
    private http = inject(HttpClient);
    private confirmDialog = inject(ConfirmDialogService);
    private messageService = inject(MessageService);
    private currentUserSvc = inject(CurrentUserService);
    private tenantSvc = inject(TenantService);

    protected get allowed(): boolean {
        return this.currentUserSvc.hasUber();
    }

    purge() {
        this.confirmDialog.open(
            'Purge Test Company',
            `This will permanently delete all data for '${TEST_SLUG}'. This cannot be undone.`,
            () => {
                this.http.post<{ message: string }>(this.tenantSvc.getPath('test/purge-tenant'), { slug: TEST_SLUG }).subscribe({
                    next: (res) => this.messageService.show(res.message),
                    error: (err) => this.messageService.showErrorMessage(err.error?.error ?? 'Purge failed'),
                });
            },
            'Purge'
        );
    }
}
